
/**
 * @nullable
 */
export type GetCourseDraftById200Level = typeof GetCourseDraftById200Level[keyof typeof GetCourseDraftById200Level] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCourseDraftById200Level = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
